import { defineElement, html, TemplateElement } from '@webtides/element-js';
import imageStyles from './image-modal.css';
import ModalElementEvent from '../modal-element/ModalElementEvent';
import ImageModalEvent from './ImageModalEvent';

class ImageModal extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }
    properties() {
        return {
            title: '',
            modalId: 0,
            imgSrc: '',
            imgAlt: '',
            darkMode: false,
            container: true,
            showArrows: false,
            disableZoom: false,
            updateHash: true,
        };
    }

    styles() {
        return [imageStyles];
    }

    open() {
        this.$refs.modal.open();
    }

    close() {
        this.$refs.modal.close();
    }

    isOpen() {
        return this.$refs.modal.openState;
    }

    connected() {
        if (this.darkMode) {
            this.classList.add('dark-mode');
        }
    }

    watch() {
        return {
            imgSrc: newSrc => {
                this.$refs.zoomImage.src = newSrc;
            },
        };
    }
    events() {
        return {
            'modal-element': {
                [ModalElementEvent.OPEN]: () => {
                    this.$refs.panZoom?.reset();
                },
            },
            '[ref=next]': {
                click: () => {
                    this.dispatch(ImageModalEvent.NEXT, null, true);
                },
            },
            '[ref=prev]': {
                click: () => {
                    this.dispatch(ImageModalEvent.PREV, null, true);
                },
            },
        };
    }

    renderImage() {
        const image = html`
            <lazy-src class="focus:outline-none block">
                <img ref="zoomImage" class="zoom-image " alt="${this.imgAlt}" data-src="${this.imgSrc}" alt="image" />
            </lazy-src>
        `;

        if (this.disableZoom) {
            return image;
        }

        return html` <pan-zoom ref="panZoom" selector="img" disable-zoom="${this.disableZoom}"> ${image} </pan-zoom> `;
    }

    template() {
        return html`
            <modal-element
                modal-id="${this.modalId}"
                ref="modal"
                type="full"
                header-container="false"
                minimal-ui="true"
                cloak="display-none"
                cloak-until-open="true"
                class="dark-mode"
                update-hash="${this.updateHash}"
            >
                <div slot="title" class="text-center font-medium ">
                    <div class="truncate uppercase">${this.title}</div>
                </div>
                <div slot="close" class="text-center pointer-events-auto">
                    <div class="p-2 hover:text-brand-500" data-modal-close>
                        <svg-icon name="close" class="pointer-events-none w-4 h-4"></svg-icon>
                    </div>
                </div>
                <div slot="content" class="absolute inset-0 overflow-hidden flex items-center justify-center">
                    <div class="${this.container ? 'container' : ''}">
                        <div class="${this.container ? 'reset-container' : ''}">${this.renderImage()}</div>
                    </div>

                    ${this.showArrows
                        ? html`
                              <button ref="prev" class="navigation-button prev hover:text-brand-500 z-10 p-2 ml-4">
                                  <svg-icon name="prev" class="h-4 w-4"></svg-icon>
                              </button>

                              <button ref="next" class="navigation-button next hover:text-brand-500 z-10 p-2 mr-4">
                                  <svg-icon name="next" class="h-4 w-4"></svg-icon>
                              </button>
                          `
                        : ''}
                </div>
            </modal-element>
        `;
    }
}

defineElement('image-modal', ImageModal);
